function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Config = function () {
    function Config() {
        var _this = this;

        _classCallCheck(this, Config);

        this.initJournalistId = function (id) {
            _this.journalistId = id;
        };

        this.enabledPhoto = function (isEnabled) {
            _this.isPhotoEnabled = isEnabled;
        };

        this.config = undefined;
        this.journalistId = 'TpwLUIwuNtYbu1QwOSFe7QPhuKY2';
        this.isPhotoEnabled = false;
    }

    Config.prototype.initConfig = function initConfig(config) {
        this.config = config;
    };

    return Config;
}();

export var config = new Config();


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/conf/config.js
// module id = 39
// module chunks = 0